module.exports = __webpack_public_path__ + "img/icon_to_top_hover.591f65ee.svg";